<template>
  <div class="min-vh main-theme">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "EDIT" : "CREATE" }} MESSAGE TEMPLATE
      </h1>
    </div>
    <div class="mt-3 bg-white-border p-3" v-if="!isLoading">
      <b-row>
        <b-col md="6">
          <InputText
            textFloat="Template Name"
            placeholder="Template Name"
            type="text"
            name="emailTemplateName"
            v-model="form.name"
            isRequired
            :readonly="form.id != 0"
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <InputSelect
            title="Category"
            name="form.category"
            isRequired
            v-model="form.category"
            :options="categoryList"
            valueField="nameEng"
            textField="nameEng"
            :disabled="form.id > 0"
            @onDataChange="(val) => (form.category = val)"
            :isValidate="$v.form.category.$error"
            :v="$v.form.category"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <InputText
            textFloat="Header"
            placeholder="Header"
            type="text"
            name="emailTemplateSubject"
            v-model="form.header"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <InputTextArea
            type="text"
            textFloat="Description"
            placeholder="Description"
            name="emailTemplateDescription"
            :detail="``"
            rows="20"
            v-model="form.detail"
            isRequired
            :isValidate="$v.form.detail.$error"
            :v="$v.form.detail"
            @onKeyup="handleKeyup"
          ></InputTextArea>
          <b-button
            class="btn btn-main btn-details-set text-uppercase mb-2"
            @click="handleClickAddVariable()"
          >
            <font-awesome-icon size="sm" icon="plus" />
            <span> เพิ่มตัวแปร</span>
          </b-button>
        </b-col>
      </b-row>
      <div v-if="templateExampleForm">
        <b-row
          v-for="(line, lineIndex) in templateExampleForm"
          :key="lineIndex"
        >
          <b-col cols="2">
            <InputText
              placeholder="ตัวแปร"
              type="text"
              :name="'variable' + lineIndex"
              :value="`{{${lineIndex + 1}}}`"
              disabled
            />
          </b-col>
          <b-col cols="6">
            <InputText
              type="text"
              :name="'variableValue' + lineIndex"
              v-model="templateExampleForm[lineIndex]"
              isRequired
              :isValidate="$v.templateExampleForm.$each[lineIndex].$error"
              :v="$v.templateExampleForm.$each[lineIndex]"
            />
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col>
          <InputText
            textFloat="Footer (Optional)"
            placeholder="Footer"
            type="text"
            name="emailTemplateFooter"
            v-model="form.footer"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-sm-left">
          <b-button
            @click="onBack()"
            class="btn-cancel tn-details-set text-uppercase px-5"
            >CANCEL</b-button
          >
        </b-col>
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="form.id == 0 ? onCreate() : onUpdate()"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SettingEmailDetail",
  components: {
    InputText,
    InputTextArea,
    InputSelect,
  },
  validations() {
    return {
      form: {
        name: { required },
        detail: { required },
        category: { required },
      },
      templateExampleForm: {
        $each: {
          required: requiredIf(function () {
            return this.templateExampleForm.length > 0;
          }),
        },
      },
    };
  },
  data: function () {
    return {
      isDisabled: false,
      isLoading: false,
      id: this.$route.params.id,

      form: {
        id: 0,
        brandId: this.$route.query.brandID,
        name: "",
        header: "",
        detail: "",
        footer: "",
        category: "MARKETING",
      },
      categoryList: [
        { id: 1, name: "สาธารณูปโภค", nameEng: "UTILITY" },
        { id: 2, name: "การตลาด", nameEng: "MARKETING" },
      ],
      templateForm: {
        name: "",
        parameter_format: "",
        components: [],
        language: "",
        status: "",
        category: "",
        id: "",
      },
      templateExampleForm: [],
      oldKey: "",
    };
  },
  computed: {},
  watch: {},

  created: async function () {
    this.isLoading = true;
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    if (this.id) await this.getDetail();
    this.isLoading = false;
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    onBack: function () {
      this.$router.push({
        path: `/whatsapp-template`,
        query: { whatsappId: this.$route.query.whatsappId },
      });
    },

    getDetail: async function () {
      await this.axios
        .get(
          `${this.$baseUrl}/whatsapp/GetTemplate/${this.$route.query.whatsappId}/${this.id}`
        )
        .then((data) => {
          if (data.result == 1) {
            var template = data.detail;
            if (template.components) {
              this.form.id = template.id;
              let header = template.components.find((o) => o.type == "HEADER");
              let body = template.components.find((o) => o.type == "BODY");
              let footer = template.components.find((o) => o.type == "FOOTER");
              this.form.header = header ? header.text : "";
              this.form.detail = body ? body.text : "";
              this.form.footer = footer ? footer.text : "";
              this.form.category = template.category;
              this.form.name = template.name;
              this.templateForm = template;

              if (body && body.example && body.example.bodyText) {
                this.templateExampleForm = body.example.bodyText[0];
              }
            }
          }
        });
    },

    async onCreate() {
      this.$v.$touch();
      if (this.$v.form.$error || this.$v.templateExampleForm.$error) return;

      this.isDisabled = true;
      this.templateForm.name = this.form.name;
      this.templateForm.parameter_format = "";
      this.templateForm.language = "en_US";
      this.templateForm.category = this.form.category;
      this.templateForm.components = [
        { type: "HEADER", text: this.form.header, format: "TEXT" },
      ];

      let body = { type: "BODY", text: this.form.detail };

      if (this.templateExampleForm.length > 0) {
        body.example = { body_text: [this.templateExampleForm] };
      }

      this.templateForm.components.push(body);

      if (this.form.footer) {
        this.templateForm.components.push({
          type: "FOOTER",
          text: this.form.footer,
        });
      }

      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(
          `${this.$baseUrl}/whatsapp/CreateTemplate/${this.$route.query.whatsappId}`,
          this.templateForm
        )
        .then((data) => {
          if (data.result == 1) {
            this.handleSuccess(data.message);
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },

    async onUpdate() {
      this.$v.$touch();
      if (this.$v.form.$error) return;
      this.isDisabled = true;
      if (this.templateForm.components) {
        let headerIndex = this.templateForm.components.findIndex(
          (o) => o.type == "HEADER"
        );
        let bodyIndex = this.templateForm.components.findIndex(
          (o) => o.type == "BODY"
        );
        let footerIndex = this.templateForm.components.findIndex(
          (o) => o.type == "FOOTER"
        );

        if (headerIndex != -1) {
          this.templateForm.components[headerIndex].text = this.form.header;
        } else if (headerIndex == -1 && this.form.name) {
          this.templateForm.components.push({
            type: "HEADER",
            text: this.form.header,
          });
        }
        if (bodyIndex != -1) {
          this.templateForm.components[bodyIndex].text = this.form.detail;
        } else if (bodyIndex == -1 && this.form.detail) {
          this.templateForm.components.push({
            type: "BODY",
            text: this.form.detail,
          });
        }
        if (footerIndex != -1) {
          this.templateForm.components[footerIndex].text = this.form.footer;
        } else if (footerIndex == -1 && this.form.footer) {
          this.templateForm.components.push({
            type: "FOOTER",
            text: this.form.footer,
          });
        }
        this.templateForm.category = this.form.category;
      }

      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(
          `${this.$baseUrl}/whatsapp/updateTemplate/${this.$route.query.whatsappId}/${this.id}`,
          this.templateForm
        )
        .then((data) => {
          if (data.result == 1) {
            this.handleSuccess(data.message);
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },
    async handleSuccess(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT", { isShow: true, msg: msg });
      this.$router
        .push({
          path: `/whatsapp-template`,
          query: { whatsappId: this.$route.query.whatsappId },
        })
        .catch(() => {});
    },
    async handleFail(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
        isShow: true,
        msg: msg,
      });
    },
    handleClickAddVariable() {
      const index = this.templateExampleForm.length + 1;
      this.templateExampleForm.push("");
      this.form.detail += ` {{${index}}}`;
    },
    syncVariables() {
      const varMatches = [...this.form.detail.matchAll(/{{(\d+)}}/g)].map((m) =>
        Number(m[1])
      );

      const uniqueSortedVars = [...new Set(varMatches)].sort((a, b) => a - b);

      const newTemplateExampleForm = [];

      uniqueSortedVars.forEach((num, index) => {
        newTemplateExampleForm[index] = this.templateExampleForm[num - 1] ?? "";
      });

      this.templateExampleForm = newTemplateExampleForm;

      let newDetail = this.form.detail.replace(/{{(\d+)}}/g, (match, p1) => {
        const oldNum = Number(p1);
        const newIndex = uniqueSortedVars.indexOf(oldNum) + 1;
        if (newIndex > 0) {
          return `{{${newIndex}}}`;
        }
        return "";
      });

      this.form.detail = newDetail;
    },

    handleKeyup(e) {
      if (e.key === "{") {
        const textarea = e.target;
        const cursorPos = textarea.selectionStart;
        const textBeforeCursor = this.form.detail.slice(0, cursorPos);
        const lastTwoChars = textBeforeCursor.slice(-2);

        if (lastTwoChars === "{{") {
          const newIndex = this.templateExampleForm.length + 1;
          this.templateExampleForm.push("");

          const newTextBeforeCursor =
            textBeforeCursor.slice(0, -2) + `{{${newIndex}}}`;

          const textAfterCursor = this.form.detail.slice(cursorPos);

          this.form.detail = newTextBeforeCursor + textAfterCursor;

          this.$nextTick(() => {
            if (textarea && textarea.parentElement) {
              const newCursorPos = newTextBeforeCursor.length;
              textarea.selectionStart = textarea.selectionEnd = newCursorPos;
              textarea.focus();
            }
          });
        }
      }
      if (
        e.key === "Backspace" ||
        (e.key === "x" && (e.ctrlKey || e.metaKey))
      ) {
        this.syncVariables();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-theme .tabs .tab-pane.active > div {
  min-height: 235px !important;
}
</style>
